import { memoizedGroupBySelector } from '@travelnest/entities';
import { IListing } from '@travelnest/typewriter';
import { ICustomer } from '../../../../../data/entities/customer';
import { IProperty } from '../../../../../data/entities/property';
import { actions } from '../../../../../data/store';
import { getCustomerContracts } from '../../../../../entities/contracts/actions';
import { IContracts } from '../../../../../entities/contracts/types';
import { getListingsByPropertyId } from '../../../../../entities/listings/actions';
import { listingsForProperty } from '../../../../../entities/listings/selectors';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../../../../store/actions';
import { ThunkAction } from '../../../../../store/middleware';

const adminCustomerListingsViewActions = createActionCreators<
	{ T: 'ADMIN_CUSTOMER_LISTINGS_DATA_REQUEST', P: { id: string } },
	{
		T: 'ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE', P: {
			id: string,
			listings: { [propertyId: string]: IListing[] },
			properties: IProperty[],
			customer: ICustomer,
			contracts: IContracts
		}
	},
	{ T: 'ADMIN_CUSTOMER_LISTINGS_DATA_FAILURE', P: { error: Error } }
	>('ADMIN_CUSTOMER_LISTINGS_DATA_REQUEST', 'ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE', 'ADMIN_CUSTOMER_LISTINGS_DATA_FAILURE');

export const adminRequestCustomerListings = (customerId: string): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(adminCustomerListingsViewActions.ADMIN_CUSTOMER_LISTINGS_DATA_REQUEST());
	try {
		await Promise.all([
			dispatch(actions.customer.getById(customerId)),
			dispatch(actions.property.getByOwnerId(customerId)),
			dispatch(getCustomerContracts(customerId))
		]);
		const initialState = getState();
		const properties = memoizedGroupBySelector('owner_id', initialState.data.properties.byId)[customerId] || [];
		const customer = initialState.data.customers.byId[customerId];
		const contracts = initialState.entities.channels.contracts[customerId];

		await Promise.all(properties.map((p) => {
			return dispatch(getListingsByPropertyId(p.id)).catch(() => []);
		}));

		const newState = getState();
		const listings = properties.reduce((keyed, property) => {
			keyed[property.id] = listingsForProperty(property.id, newState);
			return keyed;
		}, {} as { [key: string]: IListing[]});

		dispatch(adminCustomerListingsViewActions.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE({ id: customerId, listings, properties, customer, contracts }));
	} catch (error) {
		dispatch(adminCustomerListingsViewActions.ADMIN_CUSTOMER_LISTINGS_DATA_FAILURE({ error }));
	}
};

type AdminCustomerListingActions = ActionValues<typeof adminCustomerListingsViewActions>;
type AdminCustomerListingActionTypes = ActionTypeNames<AdminCustomerListingActions>;
export type Actions = AdminCustomerListingActions[keyof AdminCustomerListingActions];
export const ActionTypes = Object.keys(adminCustomerListingsViewActions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as AdminCustomerListingActionTypes);
